import styled from "styled-components";
import Block, { BlockContent } from "~/components/Block";
import { StoryDocument } from "~/external/v2/types";

type StoriesNavigationProps = {
  spacingTop?: number;
  spacingBottom?: number;
  backgroundColor?: string;
  color?: string;
  merged: { categories: CategoryWithStories[] };
};

type CategoryWithStories = {
  uid: string;
  content: {
    title: string;
  };
  stories: StoryDocument[];
};

const StoriesNavMenu = styled.div<any>`
  display: flex;

  h3 {
    margin: 0 25px 15px 0;

    a {
      color: #000;
      text-decoration: none;
    }
    a:hover {
      text-decoration: underline;
    }
  }

  /* For mobile */
  @media (max-width: 1024px) {
    justify-content: flex-start;
    flex-wrap: wrap;

    h3 {
      font-size: 14px;
    }
  }

  /* For desktop */
  @media (min-width: 1024px) {
    justify-content: center;
  }
`;

export default function StoriesNavigation(props: StoriesNavigationProps) {
  const {
    spacingTop = 0,
    spacingBottom = 6,
    color,
    backgroundColor,

    merged = { categories: [] },
  } = props;

  return (
    <Block
      spacingTop={spacingTop}
      spacingBottom={spacingBottom}
      backgroundColor={backgroundColor}
      color={color}
    >
      <BlockContent>
        <StoriesNavMenu>
          {merged.categories.map((category) => (
            <h3 key={category.uid}>
              <a href={`/stories/${category.uid}`}>
                {category.content.title} ({category.stories.length})
              </a>
            </h3>
          ))}
        </StoriesNavMenu>
      </BlockContent>
    </Block>
  );
}
